import { environment } from "./../../environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK,
  STORAGE_KEY_ACCESS_TOKEN_WSO2,
} from "../storageCore/constStorageKeys";
import storageX from "../storageCore/storageX";

@Injectable({
  providedIn: "root",
})
export class MarkerService {
  constructor(private http: HttpClient) {}

  private buildAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      Authorization:
        "Bearer " +
        `${storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).get()}`,
      "Content-Type": "application/json",
    };
    const keycloakToken = storageX
      .whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK)
      .get();
    if (keycloakToken) {
      headers["kc-auth"] = "Bearer " + keycloakToken;
    }
    return headers;
  }

  public getPosicaoAtualTerminalId(id: string): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/${"posicao-atual-terminal"}/${id}`,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public getEnderecoByPlaca(placa: string): Observable<{ endereco?: string }> {
    return this.http
      .get<{ endereco?: string }>(
        `${environment.apiUrl}/posicao-atual-terminal/latlong/${encodeURIComponent(
          placa
        )}`,
        {
          headers: this.buildAuthHeaders(),
        }
      )
      .pipe(map((body) => ({ endereco: body?.endereco })));
  }

  public getEnderecoByCoordinates(
    latitude: number,
    longitude: number
  ): Observable<{ endereco?: string }> {
    return this.http.get<{ endereco?: string }>(
      `${environment.apiUrl}/posicao-atual-terminal/endereco`,
      {
        headers: this.buildAuthHeaders(),
        params: {
          latitude: String(latitude),
          longitude: String(longitude),
        },
      }
    );
  }

  public postVariasCercasEletronicas(payload): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/${"cerca-eletronica"}/${"all"}`,
      payload,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }
}
